import { render } from "./PatientProfileModal.vue?vue&type=template&id=595ec057&scoped=true&ts=true"
import script from "./PatientProfileModal.vue?vue&type=script&lang=ts"
export * from "./PatientProfileModal.vue?vue&type=script&lang=ts"

import "./PatientProfileModal.vue?vue&type=style&index=0&id=595ec057&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595ec057"]])

export default __exports__